/**
 * Слой стяжки комнат.
 */
import { create } from "zustand";
import { ScreedMaterial } from "@/shared/catalog";
import type { RoomScreed } from "@/shared/plan";

interface ScreedLayerState {
	items: Record<string, RoomScreed>;
	visible: boolean;

	setRoomScreedMaterial: (roomId: string, material: ScreedMaterial) => void;
	removeRoomScreed: (roomId: string) => void;

	setVisible: (visible: boolean) => void;
	toggleVisible: () => void;

	restoreScreed: (roomScreed: Record<string, RoomScreed>) => void;
}

export const useScreedStore = create<ScreedLayerState>((set) => ({
	items: {},
	visible: false,

	setRoomScreedMaterial: (roomId: string, material: ScreedMaterial) =>
		set((s) => {
			const roomScreed = {
				...s.items,
				[roomId]: {
					id: roomId,
					roomId,
					material,
				},
			};
			return { items: roomScreed };
		}),

	removeRoomScreed: (roomId) =>
		set((s) => {
			if (!s.items[roomId]) return s;
			const roomScreed = { ...s.items };
			delete roomScreed[roomId];
			return { items: roomScreed };
		}),

	restoreScreed: (roomScreed) => set({ items: roomScreed }),
	setVisible: (visible) => set({ visible }),
	toggleVisible: () => set((s) => ({ visible: !s.visible })),
}));
